
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Forms/MultipleSelect.html",
      function () {
        return require("private-next-pages/Forms/MultipleSelect.html.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Forms/MultipleSelect.html"])
      });
    }
  